import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=607d57aa&scoped=true&lang=pug&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardGroup.vue?vue&type=style&index=0&id=607d57aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d57aa",
  null
  
)

export default component.exports